import { Component } from 'react'
import { invalidateSession } from 'redux-simple-auth'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'

class Logout extends Component {
  componentDidMount() {
    const queryParams = new URLSearchParams()
    queryParams.set('redirect_uri', `${window.location.origin}/logged-out`)

    this.props.invalidateSession()

    window.location.replace(
      `${process.env.REACT_APP_UL_HOST}/logout?${queryParams}`
    )
  }

  render() {
    return null
  }
}

export default withRouter(
  connect(
    null,
    { invalidateSession }
  )(Logout)
)



// WEBPACK FOOTER //
// ./src/routes/logout.js